// src/pages/LeadersGrid.jsx
import React, { useState, useEffect } from "react";

export default function Candidates() {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // ✅ GET API कॉल
    fetch("https://gp-chandoli-khurd.com/backend/api/body_members/get_body_members.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setLeaders(data.body_members);
        } else {
          console.error("API Error:", data.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-700">
        Loading body members...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-bold text-black mb-6 text-center">
          कार्यकारी मंडळ
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 justify-items-center">
          {leaders.map((leader) => (
            <div key={leader.id} className="flex flex-col items-center text-center">
              <div className="w-28 h-28 mb-3 rounded-full overflow-hidden border-2 border-gray-300">
                {/* <img
                  src={leader.photo || "/images/default_avatar.jpg"} 
                  alt={leader.name}
                  className="w-full h-full object-cover"
                /> */}
                <img
                  src={
                    leader.photo
                      ? `https://gp-chandoli-khurd.com/backend/api/body_members/uploads/${leader.photo}`
                      : "/images/default_avatar.jpg"
                  }
                  alt={leader.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h2 className="font-semibold text-gray-800">{leader.name}</h2>
              <p className="text-gray-600 text-sm">{leader.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}